module.exports = __webpack_public_path__ + "static/01-b4aabe92be823fa18a808956fb67b58d.jpg";